function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5.2 -5.9 1000 1000",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 994.8 494.1 C 994.8 770.242 770.942 994.1 494.8 994.1 C 218.658 994.1 -5.2 770.242 -5.2 494.1 C -5.2 217.958 218.658 -5.9 494.8 -5.9 C 770.942 -5.9 994.8 217.958 994.8 494.1 Z M 602.164 237.095 L 602.164 282.011 L 506.127 215.534 C 502.946 211.865 498.424 210.031 493.883 210.49 C 489.805 210.49 485.736 212.324 483.47 215.534 L 144.57 450.283 C 138.226 454.859 136.414 464.029 140.955 470.449 C 145.477 477.776 154.539 479.171 160.874 474.585 L 494.818 243.055 L 828.281 474.576 C 835.068 479.161 844.14 477.327 848.662 470.898 C 853.213 464.029 851.4 454.849 844.594 450.273 L 708.208 355.835 L 708.208 237.095 C 708.208 227.456 700.042 219.212 690.536 219.212 L 620.319 219.212 C 610.33 219.212 602.174 227.465 602.164 237.095 Z M 246.074 738.213 C 246.074 759.764 263.274 777.178 284.581 777.178 L 435.004 777.178 L 435.004 530.517 L 560.495 530.517 L 560.495 777.178 L 703.233 777.178 C 724.531 777.178 741.741 759.764 741.741 738.213 L 741.741 449.366 L 493.902 275.602 L 246.074 449.366 L 246.074 738.213 Z",
    style: {
      fill: "#fff",
      stroke: "trasparent"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c4dcef86e6020e7087a6e0432a48b8a1.svg";
export { ForwardRef as ReactComponent };